import { landingRoutes } from '../modules/landing/routes';
import { departmentRoutes } from '../modules/department/routes';
import { sourceRoutes } from '../modules/source/routes';
import { themeRoutes } from '../modules/theme/routes';
import { applianceRoutes } from '../modules/appliance/routes';
import { debriefRoutes } from '../modules/debrief/routes';
import { taskRoutes } from '../modules/task/routes';
import { reportRoutes } from '../modules/report/routes';
import { incidentRoutes } from '../modules/incident/routes';
import { learningOutcomesRoutes } from '../modules/learning-outcome/routes';
import { checklistRoutes } from '../modules/checklist/routes';
import { stationRoutes } from '@/product/ams/modules/station/routes';

export const amsRoutes = [
    {
        path: 'home',
        children: landingRoutes,
    },
    {
        path: 'debrief',
        children: debriefRoutes,
    },
    {
        path: 'department',
        children: departmentRoutes,
    },
    {
        path: 'source',
        children: sourceRoutes,
    },
    {
        path: 'theme',
        children: themeRoutes,
    },
    {
        path: 'appliance',
        children: applianceRoutes,
    },
    {
        path: 'checklist',
        children: checklistRoutes,
    },
    {
        path: 'station',
        children: stationRoutes,
    },
    {
        path: 'task',
        children: taskRoutes,
    },
    {
        path: 'report',
        children: reportRoutes,
    },
    {
        path: 'incident',
        children: incidentRoutes,
    },
    {
        path: 'learning-outcome',
        children: learningOutcomesRoutes,
    },
];
